// TODO: delete this file

import styled from "styled-components"

// components
import { DashboardDebug } from "app/static/frontend/dashboards/components/DashboardDebug"

export const StyledDashboardDebug = styled(DashboardDebug)`
    &.debug {
        margin: 0 10px;
        background: #f8f8f8;
        border: 1px solid black;
        margin-top: 10px;
        padding: 10px;

        > *:not(:last-child) {
            margin-bottom: 10px;
        }

        .options > *:not(:last-child) {
            margin-bottom: 5px;
        }

        .coordinates .columns {
            columns: 120px 5;
        }
    }
`
